import React, { FC } from 'react';
import { motion } from 'framer-motion';

export const AnimatedContainer: FC<{
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    k?: string;
}> = ({ children, className, style, k }) => (
    <motion.div
        key={k}
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.2 }}
        className={className}
        style={style}
    >
        {children}
    </motion.div>
);
